import React from "react";
import cart from "../../images/shop.svg";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { GET_ACTIVE_DEALS } from "../../query/getActiveDeals";
import moment from "moment";
const ActiveDeals = () => {
  const { data: activeDealsData } = useQuery(GET_ACTIVE_DEALS, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      business_profile_id: localStorage.getItem("profile_id"),
      current_date_time: moment().format(),
      limit: 4,
    },
  });

  return (
    <div
      style={{
        padding: "5%",
        borderRadius: "0px",
        width: "540px",
      }}
    >
      <div>
        <h2
          style={{ fontSize: "20px", fontWeight: "600", fontFamily: "Inter" }}
        >
          Active Deals
        </h2>
      </div>
      <ul
        style={{
          display: "inline-block",
          listStyle: "none",
          marginTop: "4%",
          marginLeft: "-4%",
          width: "100%",
        }}
      >
        {activeDealsData?.deals?.map((item) => (
          <li style={{ width: "100%", marginTop: "4%" }}>
            <div
              style={{
                display: "inline-block",
              }}
            >
              <img
                src={cart}
                alt="cart"
                style={{ display: "inline-block", marginTop: "-10%" }}
              />
              <div
                style={{
                  display: "inline-block",
                  marginTop: "5%",
                  lineHeight: "5px",
                  marginLeft: "20px",
                }}
              >
                <p
                  style={{
                    color: "#161F3D",
                    fontFamily: "Inter",
                    fontWeight: "500",
                  }}
                >
                  {item?.name}{" "}
                </p>
                <label style={{ color: "#989DB2", fontSize: "12px" }}>
                  Created {moment(item?.created_at).startOf().fromNow()}
                </label>
              </div>
            </div>
            <div
              style={{
                display: "inline-block",
                // marginRight: "100px",
                marginTop: "10px",
                // position: "absolute",
                float: "right",
              }}
            >
              <p style={{ color: "#161F3D", fontWeight: "600" }}>
                {item?.views_count ?? 0} views
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default ActiveDeals;
